import { Action, OperationType, Position } from "puzzle";
import AnnouncementDialog from "../components/Header/Announcement/AnnouncementDialog";


export const announcementDialog: Action = [{
  className: 'xl announcement',
  moduleName: 'AnnouncementDialog',
  args: ['announcementData', 'firstName'],
  children: [{
    render: AnnouncementDialog,
    propArgs: ['announcementData', 'firstName']
  }],
  title: 'announcement.title',
  items: [{
    btnName: 'announcement.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.dialog
}]
